import { render, staticRenderFns } from "./categoryNew.vue?vue&type=template&id=083bdd4a"
import script from "./categoryNew.vue?vue&type=script&lang=js"
export * from "./categoryNew.vue?vue&type=script&lang=js"
import style0 from "./categoryNew.vue?vue&type=style&index=0&id=083bdd4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports